import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import {
  AppDatePicker,
  AppSingleSelect,
  AppTextArea,
} from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function InecoRiskManagerRiskActionForm({
  riskID,
  actionID,
  tracking,
  onShowDeleteActionModal,
  onCloseModals,
  onReloadTab,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const validationSchema = Yup.object().shape({
    responsible: Yup.number()
      .nullable()
      .required('Requerido'),
    description: Yup.string().required('Requerido'),
    state: Yup.number()
      .nullable()
      .required('Requerido'),
  });

  // > SAVE
  const handleSave = useCallback(
    async (values) =>
      axios
        .post(
          axiosPath(
            actionID === 0
              ? "api_r_user_module_inecoRiskManager_risk_action_add"
              : "api_r_user_module_inecoRiskManager_risk_action_edit"
          ),
          {
            moduleBridgeHex,
            riskID,
            actionID,
            ...values,
          }
        )
        .then(() => {
          if (isMounted.current) {
            onCloseModals();
            onReloadTab();
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, riskID, actionID]
  );
  // < SAVE

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
      initialValues={{
        description:
          tracking?.find((a) => a?.id === actionID)?.description || '',
        responsible:
          tracking?.find((a) => a?.id === actionID)?.responsible?.id || null,
        owner: tracking?.find((a) => a?.id === actionID)?.owner?.id || null,
        anotherResponsible:
          tracking?.find((a) => a?.id === actionID)?.anotherResponsible || '',
        anotherOwner:
          tracking?.find((a) => a?.id === actionID)?.anotherOwner || '',
        state: tracking?.find((a) => a?.id === actionID)?.state?.id || '',
        closeDate: tracking?.find((a) => a?.id === actionID)?.closeDate || '',
      }}
      onSubmit={handleSave}
    >
      {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-6">
              <AppSingleSelect
                options={moduleData?.inputs?.agents}
                title="Responsable"
                value={values?.responsible}
                error={errors?.responsible}
                onChange={(opt) => {
                  setFieldValue('responsible', opt);
                }}
                hasSearchBox
                required
              />
            </div>
            <div className="col-lg-6">
              <AppSingleSelect
                options={moduleData?.inputs?.agents}
                title="Propietario"
                value={values?.owner}
                error={errors?.owner}
                onChange={(opt) => {
                  setFieldValue('owner', opt);
                }}
                hasSearchBox
              />
            </div>
            <div className="col-12">
              <AppTextArea
                title="Descripción"
                onChange={(v) => setFieldValue('description', v)}
                value={values.description}
                error={errors.description}
                resize
                height="240px"
                isClearable
              />
            </div>
            <div className="col-lg-6">
              <AppTextArea
                title="Otro responsable"
                onChange={(v) => setFieldValue('anotherResponsible', v)}
                value={values.anotherResponsible}
                error={errors.anotherResponsible}
                resize
                // height="240px"
                isClearable
              />
            </div>
            <div className="col-lg-6">
              <AppTextArea
                title="Otro propietario"
                onChange={(v) => setFieldValue('anotherOwner', v)}
                value={values.anotherOwner}
                error={errors.anotherOwner}
                resize
                // height="240px"
                isClearable
              />
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={moduleData?.inputs?.actionStates}
                    title="Estado"
                    value={values?.state}
                    error={errors?.state}
                    onChange={(opt) => {
                      setFieldValue('state', opt);
                    }}
                    hasSearchBox
                    required
                  />
                </div>
                <div className="col-lg-6">
                  <AppDatePicker
                    title="Fecha de cierre"
                    value={values?.closeDate}
                    placeholder="DD/MM/YYYY"
                    onChange={(opt) => setFieldValue('closeDate', opt)}
                    popperClassName="react-datepicker-popper react-datepicker-popper-1000"
                    isClearable
                    showYearDropdown
                    showMonthDropdown
                    hasToggleType
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-sm btn-success float-right"
                disabled={isSubmitting}
              >
                {actionID !== 0 ? 'Editar' : 'Crear'}
              </button>
              {actionID !== 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger float-right mr-2"
                  onClick={() => onShowDeleteActionModal(actionID)}
                >
                  Eliminar
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm btn-outline-danger float-right mr-2"
                onClick={onCloseModals}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
